
import { ABPaymentDialog } from '../lib/ab/payment';
import { ABStepsView, makeGenreToggles } from '../lib/ab/widgets-home';
import { aTrackClick } from '../lib/mdl/a-track';
import { CLoginUser } from '../lib/mdl/c-user';
import { meAction, meUpdateEventTags } from '../lib/me/home';
import { the_user } from '../lib/me/login';
import { UIButton } from '../lib/ui/component/button';
import { UIDialog } from '../lib/ui/component/dialog';
import { $el } from '../lib/ui/elements';
import { $on } from '../lib/y/events';
import { $i18n } from '../lib/y/i18n';
import { $location } from '../lib/y/location';

class StepsDialog extends UIDialog {
    constructor() {
        super({ close: true, classes: 'm-550 c-light m-mobile-fs' });
        const goNext = () => { setStep(steps.step + 1) };

        const steps = new ABStepsView(1);
        const next = new UIButton({
            title: $i18n.tl.b_next, classes: 'ui-tint-reverse', on_click: () => {
                const s = steps.step;

                switch(s) {
                    case 0:
                        return meUpdateEventTags(genres.value).then(goNext);
                }
                return;
            }
        });

        // const cities = $tl.makeCityToggles();
        const genres = makeGenreToggles();
        // const phone = new UITextInput({ type: 'phone', placeholder: $i18n.tl.ph_phone, required: true });

        const forms = [
            // $el.DIV('l-form m-center', [
            //     $el.H3('heading', $i18n.tl.q_onboarding_1),
            //     $el.DIV('s-small'),
            //     cities
            // ]),
            $el.DIV('l-form m-center', [
                $el.H3('heading', $i18n.tl.q_onboarding_2),
                genres
            ]),
            // $el.DIV('l-form m-center', [
            //     $el.H3('heading', $i18n.tl.q_onboarding_3),
            //     $el.P('input-hint', $i18n.tl.q_onboarding_3m),
            //     $el.DIV('s-small'),
            //     phone
            // ]),
        ];

        const fixButton = () => {
            const s = steps.step;

            switch(s) {
                case 0:
                    const g = genres.value;
                    next.disabled = !g || !g.length;
                    break;
            }

            // if(s == 0) {
            //     next.disabled = cities.value == undefined;
            // } else if(s == 1) {
            // } else if(s == 2) {
            //     next.disabled = !phone.value;
            // }
        }

        const setStep = (s: number) => {
            if(s == 1)
                this.dismiss(true);

            for(let i = 0; i < 1; i++) {
                forms[i].classList.toggle('f-selected', s == i);
            }

            steps.step = s;

            fixButton();
        }

        // $on(cities, 'value', fixButton);
        $on(genres, 'value', fixButton);
        // $on(phone, 'value', fixButton);

        setStep(0);

        this.content.ui_add($el.DIV('w-block l-form m-center', [
            // steps,
            $el.DIV('tl-onboarding-switcher', forms),
            $el.DIV('l-button-row', [
                new UIButton({ title: $i18n.tl.b_skip, classes: 'ui-tint-reverse m-hollow', on_click: goNext }),
                next
            ]),
        ]));
    }
}

export class HomeOnboardingDialog extends UIDialog {
    constructor() {
        super({ close: true, classes: 'm-440 c-light m-mobile-fs' });

        this.content.ui_add($el.DIV('w-block', [
            $el.DIV('asset-onboarding'),
            $el.H2('title', $i18n.tl.h_onboarding),
            $el.P('text', $i18n.tl.t_onboarding),
            $el.DIV('l-button-row b b-content', [
                new UIButton({
                    title: $i18n.tl.b_fill_later, classes: ['ui-tint-reverse', 'm-hollow'], on_click: () => {
                        this.dismiss(true);
                    }
                }),
                new UIButton({
                    title: $i18n.tl.b_lets_go, classes: 'ui-tint-reverse', on_click: () => {
                        new StepsDialog().present({ replace: this });
                    }
                })
            ]),
        ]));
    }
}

export class HomeTrustlyDialog extends UIDialog {
    constructor() {
        super({ close: true, track_as: 'trustly', classes: 'm-440 m-mobile-fs' });

        this.content.ui_add($el.DIV('w-block', [
            $el.H2('heading', "Dags att uppdatera din betalmetod"),
            $el.P('text', "Vi uppgraderar vårt betalsystem för att göra Abundo ännu smidigare. För att din prenumeration ska rulla på som vanligt och du inte ska missa några kommande upplevelser, behöver du snabbt uppdatera dina betalningsuppgifter. Det tar bara en minut!"),
            $el.DIV('l-button-row b b-content', [
                new UIButton({
                    title: "Uppdatera", classes: 'ui-tint-reverse', on_click: () => {
                        aTrackClick('trustly.update');
                        meAction('change_payment').then(intent => {
                            new ABPaymentDialog(intent, {
                                finish: (model: CLoginUser) => {
                                    Object.assign(the_user!, model);
                                    $location.reload();
                                }
                            }, { title: $i18n.tl.b_change_payment }).present({ replace: this });
                        });
                    }
                })
            ]),
        ]));
    }
}
